// extracted by mini-css-extract-plugin
export default {"errorBorder":"FilterCheckBox_errorBorder__tObyN"};